<template>
  <div class="support-tab-chevron-container">
    <icon-chevron-left color="#ffffff"></icon-chevron-left>
  </div>
</template>
<script>
import IconChevronLeft from '../../assets/icons/icon-chevron-left.vue';
export default {
  components: {
    IconChevronLeft,
  },
};
</script>
<style scoped>
.support-tab-chevron-container {
  width: 25px;
  height: 32px;
  background-color: #13a3eb;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
</style>
